var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalValueLogMslp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_10192_27328)",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3552 18.85H22.7372L23.022 18.5953C24.8465 16.963 27.4796 16 30.334 16C33.1884 16 35.8214 16.963 37.646 18.5953L37.9307 18.85H38.3128H39.967C40.5911 18.85 41.1913 19.1166 41.6098 19.5796C42.0275 20.0417 42.2309 20.6642 42.1667 21.2843C42.1667 21.2843 42.1667 21.2843 42.1667 21.2844L40.0957 41.2593L39.9813 42.3624H41.0903H44.2484V42.3625L44.2625 42.3623C44.2721 42.3622 44.2815 42.3639 44.2903 42.3674C44.2991 42.371 44.307 42.3762 44.3135 42.3826C44.3201 42.3891 44.3253 42.3968 44.3287 42.4051C44.3322 42.4134 44.334 42.4222 44.334 42.4311C44.334 42.4401 44.3322 42.4489 44.3287 42.4572C44.3253 42.4655 44.3201 42.4732 44.3135 42.4797C44.307 42.4861 44.2991 42.4913 44.2903 42.4948L44.2903 42.4948C44.2815 42.4984 44.2721 42.5001 44.2625 42.5L44.2625 42.4999H44.2484H16.4196V42.4998L16.4054 42.5C16.3959 42.5001 16.3865 42.4984 16.3777 42.4948L16.0061 43.4208L16.3777 42.4948C16.3689 42.4913 16.361 42.4861 16.3544 42.4797C16.3479 42.4732 16.3427 42.4655 16.3392 42.4572C16.3358 42.4489 16.334 42.4401 16.334 42.4311C16.334 42.4222 16.3358 42.4134 16.3392 42.4051C16.3427 42.3968 16.3479 42.3891 16.3544 42.3826C16.361 42.3762 16.3689 42.371 16.3777 42.3675C16.3865 42.3639 16.3959 42.3622 16.4054 42.3623L16.4054 42.3624H16.4196H19.5762H20.6852L20.5709 41.2593L18.5014 21.2837C18.5014 21.2836 18.5014 21.2834 18.5013 21.2833C18.4376 20.6622 18.6403 20.0411 19.0568 19.5796C19.4773 19.1153 20.0767 18.85 20.7009 18.85H22.3552ZM44.2484 43.4999C44.3902 43.5019 44.5311 43.4757 44.6627 43.4229L44.2484 43.4999Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.834 21H28.834V25.5H24.334V28.5H28.834V36H31.834V28.5H36.334V25.5H31.834V21Z",
    fill: "#03F5AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10192_27328",
    x1: 9.33398,
    y1: 2,
    x2: 60.334,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalValueLogMslp);
export default __webpack_public_path__ + "static/media/totalValueLogMSLP.6af8e64d776b104a2b86748072e880fa.svg";
export { ForwardRef as ReactComponent };